import { Component, OnInit, OnDestroy, Input, SimpleChanges } from '@angular/core';
import { Subscription } from 'rxjs';
import { AlarmService } from "../../services/alarm.service";
import { AuthenticationService } from '../../services/authentication.service';
import { WidgetService } from '../../services/widget.service';
import { Alarm } from 'src/models/alarm.model';
import { TranslateService } from '@ngx-translate/core';
import { UiMessageService } from "../../services/ui-message.service";
import { DashboardComponent } from "../../dashboard/dashboard.component";
import { VideoStreamService } from "../../services/video-stream.service";
import { FullscreenMediaPayload } from '../../fullscreen-video/fullscreen-video.component';

@Component({
  selector: 'app-zone',
  templateUrl: './zone.component.html',
  styleUrls: ['./zone.component.scss']
})

export class ZoneComponent implements OnInit, OnDestroy {
  @Input() alarm: Alarm;
  selectedAlarm: any;
  session_token: any;
  iframeUrl: string;
  errorMessage: string;
  zoneId: string;
  sensorId: string;
  isGridLocked = false;
  private gridLockSub: Subscription;
  private uiSub: Subscription;

  constructor(private alarmService: AlarmService, private authenticationService: AuthenticationService,
    private translateService: TranslateService,
    private widgetService: WidgetService,
    private ui: UiMessageService,
    private videoStreamService: VideoStreamService,
    private dashboardComponent: DashboardComponent
  ) { }

  async ngOnInit() {
    this.isGridLocked = localStorage.getItem('gridLocked') === 'true';
    this.gridLockSub = this.widgetService.gridLockedListener().subscribe((locked: boolean) => {
      this.isGridLocked = locked;
    });
    if (this.alarm) {
      await this.loadZone(this.alarm);
    }
    this.uiSub = this.ui.onMessage().subscribe(async msg => {
      let invalidUrl: boolean = false;
      if (msg.type === 'PLAY_STREAM') {
        const response = await this.videoStreamService.generateSourceStreamUrl(msg.data)
        let source: string[] = [];
        if (response.success && response.data && response.data.length > 0) {
          if (response.data[0] === '__INVALID_URL__') {
            invalidUrl = true;
          } else {
            source = response.data
          }
        } else {

        }
        const payload = {
          url: source,
          invalidUrl: invalidUrl
        }
        this.dashboardComponent.showOverlayWidget('fullscreen-video', payload);
      } else if (msg.type === 'SHOW_EXTERNAL_WEB_PAGE') {
        this.showExternalWebPage(msg.data);
      }
    });
  }

  showExternalWebPage(url: string) {
    const payload: FullscreenMediaPayload = {
      url: url,
      embedMode: 'webpage',
      invalidUrl: false,
    };

    this.dashboardComponent.showOverlayWidget('fullscreen-video', payload);

  }

  async ngOnChanges(changes: SimpleChanges) {
    if (changes.alarm.currentValue) {
      await this.loadZone(changes.alarm.currentValue);
    }
  }

  updateAlarm(alarm: Alarm) {
    this.loadZone(alarm);
  }

  async loadZone(alarm: Alarm) {
    this.session_token = this.authenticationService.getAuthToken();
    this.selectedAlarm = alarm;
    if (this.selectedAlarm?.sensor) {
      this.zoneId = this.selectedAlarm?.zone?.id || this.selectedAlarm?.sensor?.zone?._id;
      this.sensorId = this.selectedAlarm?.sensor?.id || this.selectedAlarm?.sensor?._id;
      let response = await this.alarmService.drawZone(this.zoneId, this.sensorId, this.session_token);
      if (response.success === true) {
        this.iframeUrl = response.url;
        this.errorMessage = '';
      } else {
        this.errorMessage = response.errorMessages[0].message;
      }
    } else {
      this.errorMessage = this.translateService.instant('MAP.NO_SENSOR_OR_ZONE');
    }
  }

  ngOnDestroy() {
    this.gridLockSub?.unsubscribe();
    this.uiSub?.unsubscribe();
  }

}
